import {
  Component,
  input,
  output,
  linkedSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Listbox, Option } from '@angular/aria/listbox';

import { ChipOptionComponent } from '../chip-option/chip-option.component';
import { ChipOption } from '../../models';

@Component({
  selector: 'app-chip-group',
  standalone: true,
  imports: [Listbox, Option, ChipOptionComponent],
  template: `
    <div
      ngListbox
      [attr.aria-label]="ariaLabel()"
      orientation="horizontal"
      selectionMode="explicit"
      multi
      [(values)]="selectedIds"
      (valuesChange)="onSelectionChange($event)"
      class="chip-group"
    >
      @for (option of options(); track option.id) {
        <app-chip-option
          ngOption
          [value]="option.id"
          [label]="option.label"
          [selected]="selectedIds().includes(option.id)"
          [disabled]="option.disabled ?? false"
        />
      }
    </div>
  `,
  styles: [
    `
      .chip-group {
        display: flex;
        flex-wrap: wrap;
        gap: 0.75rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipGroupComponent {
  options = input.required<ChipOption[]>();
  ariaLabel = input.required<string>();

  selectionChange = output<string[]>();

  // Derive selected IDs from input options, reset when options change
  selectedIds = linkedSignal<string[]>(() =>
    this.options()
      .filter((opt) => opt.selected)
      .map((opt) => opt.id)
  );

  onSelectionChange(selected: string[]): void {
    this.selectionChange.emit(selected);
  }
}
